namespace $ {

	/**
	 * One palette for the canvas and the legend, mid-toned so that every colour
	 * stays readable on both the light and the dark theme.
	 */
	export const $bog_worm_hue = {
		sensory: '#ef8b2c',
		poly: '#a366e0',
		inter: '#4d8cf5',
		motor: '#22ab6e',
		muscle: '#a1887f',
		other: '#8fa3ae',
		unknown: '#8fa3ae',
	} as Record<string, `#${ string }`>

}
